import { CustomColumn } from "../../types/customColumn";
import { ContingencyEventTable } from "../../types/dte/contingency/ContingencyEventTable";

export const contingencyEventColumns: CustomColumn<ContingencyEventTable>[] = [
  { Header: "Sucursal", accessor: "branchId" },
  { Header: "Módulo", accessor: "module" },
  {
    Header: "Estado",
    accessor: "status",
  },
  {
    Header: "Inicio",
    accessor: "startTimestamp",
  },
  {
    Header: "Fin",
    accessor: "endTimestamp",
  },
  {
    Header: "DTE Generados",
    accessor: "documentsGenerated",
  },
  {
    Header: "DTE Transmitidos",
    accessor: "documentsTransmitted",
  },
];
